import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const ContentContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemContainer = styled.div`
  flex: 1;  
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ListContainer = styled.div`
  flex: 1;  
  display: flex;
  flex-direction: column;
  gap: 9px;

  // overflow-y: auto;
  // max-height: calc(100vh - 730px);
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;